// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6945987f","574":"d20e1404"}[chunkId] + ".chunk.js";
};